<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Add Campaign to Automated Message</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickClose"
                >
                    Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-text-field
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
                v-on:input="update"
                style="margin-top: 15px"
                autocomplete="off"
            >
            </v-text-field>

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
                v-on:click:row="onAdd"
            >
            
                <template v-slot:item.action="{ item }">
                    <a 
                        v-on:click="onAdd(item)"
                    >
                        Add
                    </a>
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        content_type: {
            type: String,
            default: function() { return 'mailchimp'; }
        },
    },

    data() {
        return {
            dialog: false,
            is_valid: true,
            full_text: null,
            results: null,

            headers: [
                { text: 'Campaign Name', value: 'label'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = false;
            next(false);
            return;
        },

        onClickClose()
        {
            this.closeDialog();
        },

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/email/meta-data',
            
                {
                    'organization_id': this.$route.params.organization_id,
                    'content_type': this.content_type,
                    'full_text': this.full_text,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    // Remove campaigns that do not have a label
                    for ( let i = data.results.length-1; i >= 0; i-- )
                    {
                        if ( data.results[i].label == null || data.results[i].label.trim().length == 0 )
                        {
                            data.results.splice(i,1);
                        }
                    }

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onAdd(item)
        {
            this.$emit('input', item.email_campaign_id);
            this.closeDialog();
        },
    },
}
</script>

<style lang="scss" scoped>
</style>